module.exports = __webpack_public_path__ + "img/124.1b066146.jpg";